import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const DoubleArrowBack = createSvgIcon(
  <><path d="m15.543 1.6038-10.284 10.396 10.284 10.396-1.5996 1.5823-11.849-11.979 11.849-11.978 1.5996 1.5823z" /><path d="m21.907 1.6038-10.284 10.396 10.284 10.396-1.5996 1.5823-11.849-11.979 11.849-11.978 1.5996 1.5823z" /></>,
  'DoubleArrowBack'
);

export { DoubleArrowBack };
